import "isomorphic-fetch";
import { BatchRequestStep, BatchRequestContent, Client } from "@microsoft/microsoft-graph-client/lib/src/browser";

export abstract class BaseBatch {
    constructor(private client: Client) { }

    async buildBatchResponse(batchRequests: BatchRequestStep[]) {
        const content = await new BatchRequestContent(batchRequests).getContent();
        return await this.client
            .api('/$batch')
            .post(content);
    }
}